import { render, staticRenderFns } from "./RatingMultiple.vue?vue&type=template&id=77276913"
import script from "./RatingMultiple.vue?vue&type=script&lang=js"
export * from "./RatingMultiple.vue?vue&type=script&lang=js"
import style0 from "./RatingMultiple.vue?vue&type=style&index=0&id=77276913&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports